import { render, staticRenderFns } from "./ResultQuestionsRules.vue?vue&type=template&id=a8f20a44&scoped=true&"
import script from "./ResultQuestionsRules.vue?vue&type=script&lang=js&"
export * from "./ResultQuestionsRules.vue?vue&type=script&lang=js&"
import style0 from "./ResultQuestionsRules.vue?vue&type=style&index=0&id=a8f20a44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f20a44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol})
